import { toast } from 'react-toastify';
import { caloTheme } from 'src/theme/calo';

import ShareIcon from '@mui/icons-material/Share';
import { Button } from '@mui/material';

import { trackAffiliateShareSheetOpened } from '../../../lib/mixpanel';
import { AffiliateRes } from '../../../lib/types';

interface ShareButtonProps {
  codeName: string;
  affiliateId?: string;
  affiliate?: AffiliateRes;
  variant?: 'contained' | 'outlined';
  size?: 'small' | 'medium' | 'large';
}

const ShareButton = ({ codeName, affiliateId, affiliate, variant = 'contained', size = 'medium' }: ShareButtonProps) => {
  const handleShare = () => {
    if (affiliateId) {
      trackAffiliateShareSheetOpened(affiliateId, codeName, affiliate);
    }

    if (navigator.share) {
      navigator.share({
        title: '🎉 I\'m loving Calo\'s chef-made meals—zero cooking, all gains.',
        text: `Use my code ${codeName} to get a discount off your first plan: https://calo.app/en/plans-and-packages?promo=${codeName}`
      }).catch((error) => {
        console.error('Error sharing:', error);
        if (error.name !== 'AbortError') {
          navigator.clipboard.writeText(codeName);
          toast.success('Code copied');
        }
      });
    } else {
      navigator.clipboard.writeText(codeName);
      toast.success('Code copied');
    }
  };

  const isOutlined = variant === 'outlined';
  const isSmall = size === 'small';

  return (
    <Button
      variant={variant}
      size={size}
      startIcon={<ShareIcon />}
      onClick={handleShare}
      sx={{
        padding: isSmall ? '6px 12px' : '12px 16px',
        borderRadius: '8px',
        fontSize: isSmall ? '13px' : { xs: '14px', sm: '16px' },
        color: isOutlined ? caloTheme.palette.primary500 : caloTheme.palette.white,
        borderColor: isOutlined ? caloTheme.palette.primary500 : 'transparent',
        backgroundColor: isOutlined ? 'transparent' : caloTheme.palette.primary500,
        '&:hover': {
          backgroundColor: isOutlined ? caloTheme.palette.primary50 : caloTheme.palette.primary600,
          borderColor: isOutlined ? caloTheme.palette.primary600 : 'transparent',
          color: isOutlined ? caloTheme.palette.primary600 : caloTheme.palette.white
        },
        flex: { xs: 1, sm: 'initial' },
        fontWeight: 500,
        textTransform: 'none'
      }}
    >
      Share
    </Button>
  );
};

export default ShareButton; 